module.exports = __webpack_public_path__ + "static/me-ad7afd12fc4ef2187604c530b062adac.svg";